import { useEffect, useRef } from 'react';
import {
  useAnalyticsContext,
  useAnalyticsPost,
  NarvarEventComponents,
} from '@narvar/nth-hook-context-analytics';

import { useCustomComponentStateContext } from './useCustomComponentState';
import resolveProductRecsKind, {
  productRecsUrlHost,
} from '../lib/resolveProductRecsKind';

export const PRODUCT_RECS_FEATURE_USAGE_EVENT_TYPE = 'feature_usage';
export const PRODUCT_RECS_FEATURE = 'product_recommendations';

const useReportProductRecsKind = ({
  mlProductRecsEnabled,
}: {
  mlProductRecsEnabled: boolean | undefined;
}): void => {
  const { state } = useCustomComponentStateContext();
  const analyticsContext = useAnalyticsContext();
  const logEvent = useAnalyticsPost();
  const reportedRef = useRef(false);

  const productRecommendations =
    state?.queryData?.retailerSettings?.productRecommendations;
  const analyticsReady = Boolean(
    analyticsContext?.state?.data?.pageRetailerMoniker,
  );

  useEffect(() => {
    if (reportedRef.current) return;
    if (!analyticsReady) return;
    if (!productRecommendations) return;

    const kind = resolveProductRecsKind(
      productRecommendations,
      mlProductRecsEnabled,
    );
    if (kind === 'NONE') return;

    reportedRef.current = true;

    const host = productRecsUrlHost(productRecommendations);
    logEvent({
      eventType: PRODUCT_RECS_FEATURE_USAGE_EVENT_TYPE,
      feature: PRODUCT_RECS_FEATURE,
      eventComponent: NarvarEventComponents.NTH_BLOCK_CUSTOM_COMPONENT,
      eventFeature: NarvarEventComponents.NTH_BLOCK_CUSTOM_COMPONENT,
      pageComponent: NarvarEventComponents.NTH_BLOCK_CUSTOM_COMPONENT,
      config: [
        { name: 'product_recs_kind', options: [kind] },
        { name: 'product_recs_type', options: [productRecommendations.type] },
        ...(host ? [{ name: 'product_recs_url_host', options: [host] }] : []),
      ],
    });
  }, [analyticsReady, productRecommendations, mlProductRecsEnabled, logEvent]);
};

export default useReportProductRecsKind;
